// ***********百度在线咨询*********************************
var openUrl = "http://p.qiao.baidu.com/cps/chat?siteId=10567090&userId=5378619&siteToken=b3bb58d66da33d73b607300262397c58";//弹出窗口的url
var iWidth = 150; //弹出窗口的宽度;
var iHeight = 300; //弹出窗口的高度;
var iTop = (window.screen.availHeight - 30 - iHeight) / 2; //获得窗口的垂直位置;
var iLeft = (window.screen.availWidth - 10 - iWidth) / 2; //获得窗口的水平位置;
export function zaixianzixunM() {
  window.open(openUrl, "_blank",  'width=1400px,height=1900px,menubar=no,toolbar=no,scrollbars=yes'     );
}

// ***********百度在线咨询*********************************




